var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-page",
    { attrs: { padding: "" } },
    [
      _c(
        "div",
        { staticClass: "q-display-1 q-mb-md text-secondary" },
        [
          _c("q-icon", {
            staticClass: "q-mb-sm",
            attrs: { name: "far fa-chalkboard-teacher" }
          }),
          _vm._v(" " + _vm._s(_vm.$t(_vm.title_live_classes)) + "\n\t")
        ],
        1
      ),
      _c("filters", {
        staticClass: "filter-card",
        attrs: { options: _vm.getOptionsFilter },
        on: {
          requestFiltered: _vm.requestFiltered,
          clearAndRequest: _vm.clearAndRequest
        }
      }),
      _c("q-table", {
        attrs: {
          data: _vm.live_classes,
          columns: _vm.columns,
          pagination: _vm.server_pagination,
          loading: _vm.loading,
          filter: _vm.filter,
          "row-key": "name",
          "no-data-label": _vm.$t("no_data_avaliable"),
          "no-results-label": _vm.$t("no_results_found"),
          "loading-label": _vm.$t("loading_data"),
          "rows-per-page-label": _vm.$t("items_per_page"),
          "rows-per-page-options": [5, 10, 50, 100],
          "binary-state-sort": ""
        },
        on: {
          "update:pagination": function($event) {
            _vm.server_pagination = $event
          },
          request: _vm.request
        },
        scopedSlots: _vm._u([
          {
            key: "top",
            fn: function(props) {
              return [
                _c("q-search", {
                  attrs: {
                    debounce: 600,
                    icon: "far fa-search",
                    placeholder: _vm.$t("search")
                  },
                  model: {
                    value: _vm.filter,
                    callback: function($$v) {
                      _vm.filter = $$v
                    },
                    expression: "filter"
                  }
                }),
                _c("div", { staticClass: "col" }),
                _vm.permissions.reports
                  ? _c(
                      "q-btn",
                      {
                        staticClass: "q-mr-sm",
                        attrs: {
                          color: "secondary",
                          disable: _vm.$buttonDelay(
                            "live_classes_report_button_delay"
                          ),
                          icon: "fas fa-download",
                          label: _vm.$t("live_classes_report")
                        },
                        on: {
                          click: function($event) {
                            return _vm.downloadReport()
                          }
                        }
                      },
                      [
                        _vm.$buttonDelay("live_classes_report_button_delay")
                          ? _c(
                              "q-tooltip",
                              {
                                attrs: {
                                  anchor: "top middle",
                                  self: "bottom middle",
                                  offset: [10, 10]
                                }
                              },
                              [
                                _vm._v(
                                  "\n\t\t\t\t\t" +
                                    _vm._s(_vm.$t("report_button_delay")) +
                                    "\n\t\t\t\t"
                                )
                              ]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  : _vm._e(),
                _c("q-btn", {
                  attrs: {
                    color: "secondary",
                    icon: "far fa-plus",
                    label: _vm.$t("new"),
                    disable: !_vm.permissions.live_classes_manage
                  },
                  on: {
                    click: function($event) {
                      return _vm.$router.push({
                        name: "admin_live_class",
                        params: { id: 0 }
                      })
                    }
                  }
                })
              ]
            }
          },
          {
            key: "header",
            fn: function(props) {
              return _c(
                "q-tr",
                { attrs: { props: props } },
                _vm._l(props.cols, function(col) {
                  return _c(
                    "q-th",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: col.show,
                          expression: "col.show"
                        }
                      ],
                      key: col.name,
                      attrs: { props: props }
                    },
                    [
                      _vm._v(
                        "\n\t\t\t\t" + _vm._s(_vm.$t(col.label)) + "\n\t\t\t"
                      )
                    ]
                  )
                }),
                1
              )
            }
          },
          {
            key: "body",
            fn: function(props) {
              return _c(
                "q-tr",
                { attrs: { props: props } },
                [
                  _c(
                    "q-td",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showColumn(props.colsMap, "id"),
                          expression: "showColumn(props.colsMap, 'id')"
                        }
                      ],
                      key: "id",
                      attrs: { "auto-width": "", props: props }
                    },
                    [_vm._v("\n\t\t\t\t" + _vm._s(props.row.id) + "\n\t\t\t")]
                  ),
                  _c(
                    "q-td",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showColumn(props.colsMap, "title"),
                          expression: "showColumn(props.colsMap, 'title')"
                        }
                      ],
                      key: "title",
                      attrs: { props: props }
                    },
                    [
                      props.row.title.length > 49
                        ? _c(
                            "span",
                            [
                              _vm._v(
                                "\n\t\t\t\t\t" +
                                  _vm._s(
                                    props.row.title.substring(0, 50) + "..."
                                  ) +
                                  "\n\t\t\t\t\t"
                              ),
                              _c("q-tooltip", [_vm._v(_vm._s(props.row.title))])
                            ],
                            1
                          )
                        : _c("span", [
                            _vm._v(
                              "\n\t\t\t\t\t" +
                                _vm._s(props.row.title) +
                                "\n\t\t\t\t"
                            )
                          ])
                    ]
                  ),
                  _c(
                    "q-td",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showColumn(props.colsMap, "code"),
                          expression: "showColumn(props.colsMap, 'code')"
                        }
                      ],
                      key: "code",
                      attrs: { props: props }
                    },
                    [_vm._v("\n\t\t\t\t" + _vm._s(props.row.code) + "\n\t\t\t")]
                  ),
                  _c(
                    "q-td",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showColumn(props.colsMap, "permission"),
                          expression: "showColumn(props.colsMap, 'permission')"
                        }
                      ],
                      key: "permission",
                      attrs: { props: props }
                    },
                    [
                      _c(
                        "q-btn",
                        {
                          attrs: {
                            color: "primary",
                            "text-color": "white",
                            label: _vm.getQuantity(props.row.permission),
                            "no-ripple": ""
                          }
                        },
                        [
                          _c("q-tooltip", [
                            props.row.permission.areas.length > 0
                              ? _c(
                                  "p",
                                  { staticClass: "tooltip q-mb-sm" },
                                  [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t" +
                                        _vm._s(_vm.$t("areas")) +
                                        ":\n\t\t\t\t\t\t\t"
                                    ),
                                    _vm._l(props.row.permission.areas, function(
                                      area,
                                      index
                                    ) {
                                      return _c("span", { key: index }, [
                                        _vm._v(
                                          "\n\t\t\t\t\t\t\t\t" +
                                            _vm._s(_vm.getArea(area)) +
                                            "\n\t\t\t\t\t\t\t\t"
                                        ),
                                        props.row.permission.areas.length - 1 >
                                        index
                                          ? _c("span", [
                                              _vm._v(",\n\t\t\t\t\t\t\t\t")
                                            ])
                                          : _vm._e()
                                      ])
                                    })
                                  ],
                                  2
                                )
                              : _vm._e(),
                            props.row.permission.clients.length > 0
                              ? _c(
                                  "p",
                                  { staticClass: "tooltip q-mb-sm" },
                                  [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t" +
                                        _vm._s(_vm.$t("clients")) +
                                        ":\n\t\t\t\t\t\t\t"
                                    ),
                                    _vm._l(
                                      props.row.permission.clients,
                                      function(client, index) {
                                        return _c("span", { key: index }, [
                                          _vm._v(
                                            "\n\t\t\t\t\t\t\t\t" +
                                              _vm._s(_vm.getClient(client)) +
                                              "\n\t\t\t\t\t\t\t\t"
                                          ),
                                          props.row.permission.clients.length -
                                            1 >
                                          index
                                            ? _c("span", [
                                                _vm._v(",\n\t\t\t\t\t\t\t\t")
                                              ])
                                            : _vm._e()
                                        ])
                                      }
                                    )
                                  ],
                                  2
                                )
                              : _vm._e()
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "q-td",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showColumn(props.colsMap, "tags"),
                          expression: "showColumn(props.colsMap, 'tags')"
                        }
                      ],
                      key: "tags",
                      attrs: { props: props }
                    },
                    [
                      _c(
                        "q-btn",
                        {
                          attrs: {
                            color: "primary",
                            "text-color": "white",
                            label: _vm.getQuantityTags(props.row.tags),
                            "no-ripple": ""
                          }
                        },
                        [
                          props.row.tags.length > 0
                            ? _c("q-tooltip", [
                                _c(
                                  "p",
                                  { staticClass: "tooltip q-mb-sm" },
                                  [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t" +
                                        _vm._s(_vm.$t("tags")) +
                                        ":\n\t\t\t\t\t\t\t"
                                    ),
                                    _vm._l(props.row.tags, function(
                                      tag,
                                      index
                                    ) {
                                      return _c("span", { key: index }, [
                                        _vm._v(
                                          "\n\t\t\t\t\t\t\t\t" +
                                            _vm._s(_vm.getTag(tag)) +
                                            "\n\t\t\t\t\t\t\t\t"
                                        ),
                                        props.row.tags.length - 1 > index
                                          ? _c("span", [_vm._v(", ")])
                                          : _vm._e()
                                      ])
                                    })
                                  ],
                                  2
                                )
                              ])
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "q-td",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showColumn(props.colsMap, "owners"),
                          expression: "showColumn(props.colsMap, 'owners')"
                        }
                      ],
                      key: "owners",
                      attrs: { props: props }
                    },
                    [
                      _c(
                        "q-btn",
                        {
                          attrs: {
                            color: "primary",
                            "text-color": "white",
                            label: _vm.getQuantityOwners(props.row.owners),
                            "no-ripple": ""
                          }
                        },
                        [
                          props.row.owners.length > 0
                            ? _c("q-tooltip", [
                                _c(
                                  "p",
                                  { staticClass: "tooltip q-mb-sm" },
                                  [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t" +
                                        _vm._s(_vm.$t("owners")) +
                                        ":\n\t\t\t\t\t\t\t"
                                    ),
                                    _vm._l(props.row.owners, function(
                                      owner,
                                      index
                                    ) {
                                      return _c("span", { key: index }, [
                                        _vm._v(
                                          "\n\t\t\t\t\t\t\t\t" +
                                            _vm._s(owner) +
                                            "\n\t\t\t\t\t\t\t\t"
                                        ),
                                        props.row.owners.length - 1 > index
                                          ? _c("span", [_vm._v(", ")])
                                          : _vm._e()
                                      ])
                                    })
                                  ],
                                  2
                                )
                              ])
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "q-td",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showColumn(props.colsMap, "is_public"),
                          expression: "showColumn(props.colsMap, 'is_public')"
                        }
                      ],
                      key: "is_public",
                      attrs: { props: props }
                    },
                    [
                      _vm._v(
                        "\n\t\t\t\t" +
                          _vm._s(_vm.getLiveClassType(props.row.is_public)) +
                          "\n\t\t\t"
                      )
                    ]
                  ),
                  _c(
                    "q-td",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showColumn(props.colsMap, "platform_type"),
                          expression:
                            "showColumn(props.colsMap, 'platform_type')"
                        }
                      ],
                      key: "platform_type",
                      attrs: { props: props }
                    },
                    [
                      _vm._v(
                        "\n\t\t\t\t" +
                          _vm._s(
                            _vm.getLiveClassPlatformTypes(
                              props.row.platform_type
                            )
                          ) +
                          "\n\t\t\t"
                      )
                    ]
                  ),
                  _c(
                    "q-td",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showColumn(
                            props.colsMap,
                            "live_class_date"
                          ),
                          expression:
                            "showColumn(props.colsMap, 'live_class_date')"
                        }
                      ],
                      key: "live_class_date",
                      attrs: { props: props }
                    },
                    [
                      _vm._v(
                        "\n\t\t\t\t" +
                          _vm._s(props.row.live_class_date) +
                          "\n\t\t\t"
                      )
                    ]
                  ),
                  _c(
                    "q-td",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showColumn(props.colsMap, "created_date"),
                          expression:
                            "showColumn(props.colsMap, 'created_date')"
                        }
                      ],
                      key: "created_date",
                      attrs: { props: props }
                    },
                    [
                      _vm._v(
                        "\n\t\t\t\t" +
                          _vm._s(props.row.created_date) +
                          "\n\t\t\t"
                      )
                    ]
                  ),
                  _c(
                    "q-td",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showColumn(props.colsMap, "updated_date"),
                          expression:
                            "showColumn(props.colsMap, 'updated_date')"
                        }
                      ],
                      key: "updated_date",
                      attrs: { props: props }
                    },
                    [
                      _vm._v(
                        "\n\t\t\t\t" +
                          _vm._s(props.row.updated_date) +
                          "\n\t\t\t"
                      )
                    ]
                  ),
                  _c(
                    "q-td",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showColumn(
                            props.colsMap,
                            "unpublish_date"
                          ),
                          expression:
                            "showColumn(props.colsMap, 'unpublish_date')"
                        }
                      ],
                      key: "unpublish_date",
                      attrs: { props: props }
                    },
                    [
                      _vm._v(
                        "\n\t\t\t\t" +
                          _vm._s(props.row.unpublish_date) +
                          "\n\t\t\t"
                      )
                    ]
                  ),
                  _c(
                    "q-td",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showColumn(props.colsMap, "status"),
                          expression: "showColumn(props.colsMap, 'status')"
                        }
                      ],
                      key: "status",
                      attrs: { props: props, "auto-width": "" }
                    },
                    [
                      _c(
                        "q-chip",
                        {
                          staticClass: "full-width",
                          attrs: {
                            small: "",
                            icon: _vm.getIconStatus(props.row),
                            color: _vm.getColorStatus(props.row)
                          }
                        },
                        [
                          _vm._v(
                            "\n\t\t\t\t\t" +
                              _vm._s(_vm.$t(_vm.getStatus(props.row))) +
                              "\n\t\t\t\t"
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _c(
                    "q-td",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showColumn(props.colsMap, "actions"),
                          expression: "showColumn(props.colsMap, 'actions')"
                        }
                      ],
                      key: "actions",
                      attrs: { props: props }
                    },
                    [
                      _c(
                        "q-btn",
                        {
                          attrs: {
                            flat: "",
                            round: "",
                            color: "primary",
                            icon: "far fa-pencil-alt"
                          },
                          on: {
                            click: function($event) {
                              return _vm.$router.push({
                                name: "admin_live_class",
                                params: { id: props.row.actions }
                              })
                            }
                          }
                        },
                        [
                          _c("q-tooltip", [
                            _vm._v(
                              "\n\t\t\t\t\t\t" +
                                _vm._s(_vm.$t("view_or_edit_tooltip")) +
                                "\n\t\t\t\t\t"
                            )
                          ])
                        ],
                        1
                      ),
                      _c(
                        "q-btn",
                        {
                          attrs: {
                            flat: "",
                            round: "",
                            color: "secondary",
                            icon: "far fa-chart-line"
                          },
                          on: {
                            click: function($event) {
                              return _vm.showTrainingReport(props.row)
                            }
                          }
                        },
                        [
                          _c("q-tooltip", [
                            _vm._v(
                              "\n\t\t\t\t\t\t" +
                                _vm._s(
                                  _vm.$t(
                                    "view_report_for_this_live_class_tooltip"
                                  )
                                ) +
                                "\n\t\t\t\t\t"
                            )
                          ])
                        ],
                        1
                      ),
                      _c(
                        "q-btn",
                        {
                          attrs: {
                            flat: "",
                            round: "",
                            color: "negative",
                            icon: "far fa-trash-alt",
                            disable: !_vm.permissions.live_classes_manage
                          },
                          on: {
                            click: function($event) {
                              return _vm.confirmRemove(props.row.actions)
                            }
                          }
                        },
                        [
                          _c("q-tooltip", [
                            _vm._v(
                              "\n\t\t\t\t\t\t" +
                                _vm._s(_vm.$t("delete_tooltip")) +
                                "\n\t\t\t\t\t"
                            )
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            }
          },
          {
            key: "bottom-row",
            fn: function(props) {
              return _c(
                "q-tr",
                { attrs: { props: props } },
                [
                  _c(
                    "q-td",
                    { attrs: { colspan: "100%" } },
                    [
                      _c(
                        "q-btn",
                        {
                          attrs: {
                            flat: "",
                            round: "",
                            dense: "",
                            color: "secondary",
                            size: "small",
                            icon: "far fa-cog"
                          },
                          on: {
                            click: function($event) {
                              _vm.show_customize_columns = true
                            }
                          }
                        },
                        [
                          _c("q-tooltip", [
                            _vm._v(
                              "\n\t\t\t\t\t\t" +
                                _vm._s(_vm.$t("configure_table_tooltip")) +
                                "\n\t\t\t\t\t"
                            )
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            }
          }
        ])
      }),
      _c(
        "q-modal",
        {
          attrs: {
            "content-css": {
              minWidth: _vm.getMinWidth,
              maxWidth: _vm.getMaxWidth,
              minHeight: "80vh"
            }
          },
          model: {
            value: _vm.show_customize_columns,
            callback: function($$v) {
              _vm.show_customize_columns = $$v
            },
            expression: "show_customize_columns"
          }
        },
        [
          _c(
            "q-modal-layout",
            [
              _c(
                "q-toolbar",
                { attrs: { slot: "header" }, slot: "header" },
                [
                  _c("q-btn", {
                    attrs: {
                      flat: "",
                      round: "",
                      dense: "",
                      icon: "fas fa-times"
                    },
                    on: {
                      click: function($event) {
                        return _vm.saveColumns()
                      }
                    }
                  }),
                  _c("q-toolbar-title", [
                    _vm._v(
                      "\n\t\t\t\t\t" +
                        _vm._s(_vm.$t("personalize_columns")) +
                        "\n\t\t\t\t"
                    )
                  ])
                ],
                1
              ),
              _c("div", { staticClass: "layout-padding" }, [
                _c(
                  "div",
                  { staticClass: "row gutter-md" },
                  _vm._l(_vm.columns, function(column, index) {
                    return column.label && column.label != "#"
                      ? _c(
                          "div",
                          { key: index, staticClass: "col-xs-12 col-sm-4" },
                          [
                            _c("q-checkbox", {
                              attrs: { label: _vm.$t(column.label) },
                              model: {
                                value: column.show,
                                callback: function($$v) {
                                  _vm.$set(column, "show", $$v)
                                },
                                expression: "column.show"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e()
                  }),
                  0
                ),
                _c("div", { staticClass: "row reverse gutter-md q-mt-md" }, [
                  _c(
                    "div",
                    { staticClass: "col-xs-12 col-sm-3" },
                    [
                      _c("q-btn", {
                        staticClass: "fit",
                        attrs: {
                          icon: "fal fa-times",
                          color: "primary",
                          label: _vm.$t("close")
                        },
                        on: { click: _vm.saveColumns }
                      })
                    ],
                    1
                  )
                ])
              ])
            ],
            1
          )
        ],
        1
      ),
      _c(
        "q-modal",
        {
          attrs: {
            "content-css": {
              minWidth: "100vw",
              maxWidth: "100vw",
              minHeight: "100vh"
            }
          },
          model: {
            value: _vm.show_report,
            callback: function($$v) {
              _vm.show_report = $$v
            },
            expression: "show_report"
          }
        },
        [
          _c(
            "q-modal-layout",
            [
              _c(
                "q-toolbar",
                { attrs: { slot: "header" }, slot: "header" },
                [
                  _c("q-btn", {
                    attrs: {
                      flat: "",
                      round: "",
                      dense: "",
                      icon: "fas fa-times"
                    },
                    on: {
                      click: function($event) {
                        _vm.show_report = false
                      }
                    }
                  }),
                  _c("q-toolbar-title", [
                    _vm._v(
                      "\n\t\t\t\t\t" + _vm._s(_vm.$t("reports")) + "\n\t\t\t\t"
                    )
                  ])
                ],
                1
              ),
              _c("div", { staticClass: "layout-padding" }, [
                _c(
                  "div",
                  {
                    staticStyle: {
                      position: "relative",
                      width: "100%",
                      height: "0px",
                      "padding-bottom": "56.25%"
                    }
                  },
                  [
                    _c("iframe", {
                      staticStyle: {
                        position: "absolute",
                        left: "0",
                        top: "0",
                        width: "100%",
                        height: "100%"
                      },
                      attrs: { src: _vm.report_url, frameborder: "0" }
                    })
                  ]
                )
              ])
            ],
            1
          )
        ],
        1
      ),
      _c(
        "q-dialog",
        {
          on: { ok: _vm.removeItem },
          scopedSlots: _vm._u([
            {
              key: "buttons",
              fn: function(props) {
                return [
                  _c("q-btn", {
                    attrs: { color: "primary", label: _vm.$t("cancel") },
                    on: {
                      click: function($event) {
                        _vm.confirm_remove = false
                      }
                    }
                  }),
                  _c("q-btn", {
                    attrs: { color: "negative", label: _vm.$t("remove") },
                    on: {
                      click: function($event) {
                        return _vm.removeItem()
                      }
                    }
                  })
                ]
              }
            }
          ]),
          model: {
            value: _vm.confirm_remove,
            callback: function($$v) {
              _vm.confirm_remove = $$v
            },
            expression: "confirm_remove"
          }
        },
        [
          _c("span", { attrs: { slot: "title" }, slot: "title" }, [
            _vm._v(_vm._s(_vm.$t("remove_item")))
          ]),
          _c("span", { attrs: { slot: "message" }, slot: "message" }, [
            _vm._v(_vm._s(_vm.$t("confirm_remove_item")))
          ])
        ]
      ),
      _c(
        "q-dialog",
        {
          attrs: { "prevent-close": "" },
          scopedSlots: _vm._u([
            {
              key: "buttons",
              fn: function(props) {
                return [
                  _c(
                    "div",
                    { staticClass: "row full-width q-mb-xs" },
                    [
                      _c("q-btn", {
                        staticClass: "offset-4 col-4",
                        attrs: { color: "positive", label: _vm.$t("ok") },
                        on: {
                          click: function($event) {
                            _vm.show_report_problem = false
                          }
                        }
                      })
                    ],
                    1
                  )
                ]
              }
            }
          ]),
          model: {
            value: _vm.show_report_problem,
            callback: function($$v) {
              _vm.show_report_problem = $$v
            },
            expression: "show_report_problem"
          }
        },
        [
          _c("span", { attrs: { slot: "title" }, slot: "title" }, [
            _vm._v(_vm._s(_vm.$t("report_download_failed")))
          ]),
          _c("div", { attrs: { slot: "message" }, slot: "message" }, [
            _c("span", { staticClass: "q-pa-xs" }, [
              _vm._v(_vm._s(_vm.$t("report_download_failed_exceeded_time")))
            ]),
            _c("p", { staticClass: "q-pa-xs" }, [
              _vm._v(_vm._s(_vm.$t("the_report_it_will_be_sent_to_your_email")))
            ])
          ])
        ]
      ),
      _vm.show_report_training
        ? _c("reports", {
            attrs: {
              show_report_training: _vm.show_report_training,
              permissions: _vm.permissions.reports,
              id: _vm.action_id,
              title: _vm.action_title
            },
            on: {
              hide_report: function($event) {
                return _vm.hideReport()
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }